// extracted by mini-css-extract-plugin
export default {"wrapper":"Composer_wrapper__diw70","inputRow":"Composer_inputRow__YvgqL","sendButton":"Composer_sendButton__PvLaz","aiButton":"Composer_aiButton__N7HUP"};